import { t } from '../../../../../../common/i18n.js'
import type { Language } from '../../../../../../common/types/i18n.js'
import type { LeaderboardCardPayload } from '../../../../../../server/controllers/portal/dashboard-card-payloads.js'
import { BadgeArt } from '../../../../../components/badge-art/badge-art.js'
import './leaderboard-card.css'

export const LeaderboardCard = ({
    data,
    lang,
}: {
    data: LeaderboardCardPayload
    lang: Language
}) => {
    const c = t.portal.dashboard.cards.leaderboard

    return (
        <>
            <span className="portal-card__label">{c.rankingsHeading(lang)}</span>
            <div className="portal-card__rankings">
                {data.rankings.map((row) => (
                    <div
                        key={row.rank}
                        className={`portal-card__ranking-row${
                            row.isCurrentUser ? ' portal-card__ranking-row--current' : ''
                        }`}
                    >
                        <span className="portal-card__ranking-name">
                            {row.rank}. {row.name}
                        </span>
                        <span className="portal-card__ranking-score">
                            {c.points(row.score)(lang)}
                        </span>
                    </div>
                ))}
            </div>
            {data.lastBadge && (
                <div className="portal-leaderboard-card__last-badge">
                    <span className="portal-card__label">{c.lastBadgeLabel(lang)}</span>
                    <div className="portal-leaderboard-card__badge">
                        <BadgeArt
                            className="portal-leaderboard-card__badge-img"
                            art={data.lastBadge.art}
                            state="active"
                            idPrefix="dash-last"
                            size={48}
                        />
                        <span className="portal-leaderboard-card__badge-name">
                            {data.lastBadge.name}
                        </span>
                    </div>
                </div>
            )}
        </>
    )
}
